
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pakkereiser/hotell",
      function () {
        return require("private-next-pages/pakkereiser/hotell.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pakkereiser/hotell"])
      });
    }
  